module.exports = __webpack_public_path__ + "img/clock.7593e311.svg";